<div class="infoFormDv">
  <i class="fa fa-times closeInfoDv" aria-hidden="true" (click)="closeDialog()"></i>
  <div>
    <div class="HeadingDv">
      <h2>Coupon Redeemed By Following Users</h2>
    </div>
    <div class="gridDv">
      <div class="iteminfoGridDv" *ngFor="let item of customers">
        <figure *ngIf="!item.photoUrl">
          <img src="../../../assets/images_v2/dummyProfile.png">
        </figure>
        <figure *ngIf="item.photoUrl">
          <img [src]="item?.photoUrl">
        </figure>
        <div class="textDv">
          <h1>{{item?.firstName}} {{item?.lastName}}</h1>
          <p>{{item?.email}}</p>
        </div>
      </div>
      <div class="noDataFound" *ngIf="!customers.length">
        <p>No Data Found!</p>
      </div>
    </div>
  </div>
</div>
